import { render, staticRenderFns } from "./AdminStandardImport.vue?vue&type=template&id=49d70ee7"
import script from "./AdminStandardImport.vue?vue&type=script&lang=js"
export * from "./AdminStandardImport.vue?vue&type=script&lang=js"
import style0 from "./AdminStandardImport.vue?vue&type=style&index=0&id=49d70ee7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports